module.exports = __webpack_public_path__ + "img/sudoku.62a2795b.svg";